import { useMemo, useState } from "react"
import cn from "classnames"
import ArchiveCard from "components/ArchiveCard"
import Arrow from "public/assets/down-arrow-blue-background.svg"

export default function PracticeAreaChildArchive({ name, items }) {
  const lastIndex = useMemo(() => items?.length - 1, [items.length])
  const [currentSlide, setSlide] = useState(0)

  return items?.length > 0 ? (
    <section className="child-archive bg-highlight-tint py-8 lg:py-16 px-5 overflow-hidden relative">
      <div className="max-w-screen-xl mx-auto">
        <h2 className="text-center text-primary">Types of {name} Cases</h2>
        <div
          className="flex transition-all duration-700 gap-4 px-2 sm:grid sm:grid-cols-2 lg:grid-cols-4 sm:gap-8 pt-8 sm:translate-x-0"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
        >
          {items.map((item, idx) => {
            const visible = idx === currentSlide

            return (
              <div
                className={cn("min-w-full transform transition-all duration-500 relative h-full block min-h-full", {
                  "opacity-100": visible,
                  "opacity-0 sm:opacity-100": !visible,
                })}
                key={item.name}
              >
                <ArchiveCard {...item} />
              </div>
            )
          })}
        </div>
        {items?.length > 1 ? (
          <div className="flex sm:hidden gap-12 mt-8 justify-center">
            <button
              onClick={() => setSlide(currentSlide === 0 ? lastIndex : currentSlide - 1)}
              aria-label="Previous Slide"
            >
              <Arrow className="rotate-90 w-10" />
            </button>
            <button onClick={() => setSlide(currentSlide === lastIndex ? 0 : currentSlide + 1)} aria-label="Next Slide">
              <Arrow className="-rotate-90 w-10" />
            </button>
          </div>
        ) : null}
      </div>
    </section>
  ) : null
}
